
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 5H5.894C4.296 5 3 6.425 3 8.184v4.776c0 1.758 1.296 3.184 2.894 3.184l2.705-.013 3.776 3.244c.216.194 2.48 2.007 2.731 1.875.252-.132-.722-2.425-.722-2.733l-.533-2.373h1.255c1.598 0 2.894-1.426 2.894-3.184V11.5","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18 2v6M21 5h-6","stroke":"#F4A226","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    